export enum QcqOperations { ADD, EDIT, REMOVE }

export enum ShiftFilterScope { AllShifts, FixedShifts, TemporaryShifts, Active, Inactive, Closed, Invoiced }

export enum DatePeriodEnum {
  Week = 'week',
  Month = 'month',
  Day = 'day',
  Year = 'year',
  WorkingWeek = 'workingWeek'
}

export enum ViewEnum {
  TimelineWeek = 'timelineWeek',
  Week = 'Week',
  TimelineMonth = 'timelineMonth',
  Month = 'month',
  Day = 'day',
  TimelineYear = 'timelineYear',
  Timeline4Month = 'timeline4Month',
  TimelineWorkDaysWeek = 'timelineWorkDaysWeek'
}

export enum KindOfShift { Qcq, Free, Unknown }

export enum ShiftAvailability { Temporary, Fixed }

export enum SchedulerResourceEnum { Employee, PlanningGroup }

export enum SnackbarStateEnum { Error, Success }

export enum MasterDataActionsEnum {
  Create = 'Insert',
  Read = 'Grab',
  Update = 'Update',
  Delete = 'Delete'
}

export enum MenuDataEnum {
  Simple = 'Simple',
  Industrial = 'Industrial',
  PlanningData = 'PlanningData',
  CompanyData = 'CompanyData',
  CompanyDataSettings = 'CompanyDataSettings',
  Department = 'Department',
  ProfitCenter = 'ProfitCenter',
  Employee = 'Employee',
  DepartmenSettings = 'DepartmenSettings',
  ProfitCenterSettings = 'ProfitCenterSettings',
  EmployeeSettings = 'EmployeeSettings',
  ProfitCenterSettingsWithDepartment = 'ProfitCenterSettingsWithDepartment',
  EmployeeHierarchySettings = 'EmployeeHierarchySettings',
  ProfitCenterSettingsPage = 'ProfitCenterSettingsPage',
  ProfitCenterAdditionalFieldsSettings = 'ProfitCenterAdditionalFieldsSettings',
  CommissionGroup = 'CommissionGroup',
  CommissionGroupItem = 'CommissionGroupItem',
  AddressGroup = 'AddressGroup',
  AddressGroupItem = 'AddressGroupItem',
  AddressItem = 'AddressItem',
  ProjectGroup = 'ProjectGroup',
  ProjectGroupItem = 'ProjectGroupItem',
  ProductGroup = 'ProductGroup',
  ProductGroupItem = 'ProductGroupItem',
  RecruitingGroup = 'RecruitingGroup',
  RecruitingGroupItem = 'RecruitingGroupItem',
  ToolsGroup = 'ToolsGroup',
  ToolsGroupItem = 'ToolsGroupItem',
  TicketingGroup = 'TicketingGroup',
  TicketingGroupItem = 'TicketingGroupItem',
  Configuration = 'Configuration',
  ConfigurationGroup = 'ConfigurationGroup',
  ConfigurationGroupItem = 'ConfigurationGroupItem',
  ConfigurationGroupWithFilter = 'ConfigurationGroupWithFilter',
  ConfigurationGroupItemWithFilter = 'ConfigurationGroupItemWithFilter'
}

export enum QcqQualification{ Education, Jobs, Specializations, Details }

export enum ActionsEnum {
  CREATE = 'Create',
  EDIT = 'Edit',
  DELETE = 'Delete'
}

export enum AbsencesFilterScope { AllAbsences, ApprovedAbsencesFalse,  ApprovedAbsencesTrue, DisapprovedAbsences }
export enum MenuFilterScope { All,  Active, Passive }
export enum NoteEditMenu { Shift,  Address, Employee }

export enum SecurityArea {
  Menu = 'menu',
  Masterdata = 'masterdata',
  PersonalDisposition = 'personaldisposition',
  Addresses = 'addresses',
  Employee = 'employee',
  Reports = 'reports',
  Absences = 'absences',
  Planning = 'planning',
  PlanningPlayground = 'planning-playground',
  PlanningBar = 'planning-bar',
  Projects = 'projects',
  ProjectDetails = 'projectdetails',
  Tools = 'tools',
  Cockpit = 'cockpit',
  Products = 'products',
}

export enum SecurityComponent {
  //Menu
  Dashboard = 'dashboard',
  Stammdaten = 'stammdaten',
  MultisiteAddressSearch = 'multisite-address-search',
  Projects = 'projects',
  PrintingActivity = 'printing-activity',
  PersonalDisposition = 'personaldisposition',
  Settings = 'settings',
  Tools = 'tools',
  Cockpit = 'cockpit',
  TicketSystem = 'ticketsystem',
  Absences = 'absences',
  Reports = 'reports',
  //Masterdata
  Products = 'products',
  Qcq = 'qcq',
  Shifts = 'shifts',
  Commission = 'commission',
  Works = 'works',
  Address = 'address',
  Timemodels = 'timemodels',
  //PersonalDisposition
  Allocation = 'allocation',
  Substitution = 'substitution',
  Reallocation = 'reallocation',
  //Addresses
  IconInsert = 'icon-insert',  //PlanningBar
  IconUpdate = 'icon-update',  //PlanningBar
  IconDelete = 'icon-delete',  //PlanningBar
  IconCopy = 'icon-copy',  //PlanningBar
  TransferButton = 'webreport-datatrasfer',
  AddressesDocuments = 'documents',
  //Employee
  Password = 'password',
  EmployeeIconInsert = 'icon-insert',
  EmployeeIconUpdate = 'icon-update',
  EmployeeDocuments = 'documents',
  //Reports
  SendEmailIcon = 'send-email-icon',
  //Absences
  IconApprove = 'icon-approve',
  SwitchApprove = 'switch-approve',
  SwitchRefuse = 'switch-refuse',
  DragDrop = 'drag&drop',
  ReasonForAbsence = 'reason-for-absence',
  ToolbarFunctions = 'toolbar-functions',  //PlanningBar
  //Planning
  SelectBoxFiliale = 'selectbox-filiale',
  SelectBoxAbteilung = 'selectbox-abteilung',
  SelectBoxSchichtvorlage = 'selectbox-schichtvorlage',
  SelectBoxAdress = 'selectbox-adress',
  SelectBoxProject = 'selectbox-project',
  SelectBoxAbo = 'selectbox-abo',
  SelectBoxKalenderArt = 'selectbox-kalender-art',
  //PlanningPlayground
  DragDropForSchichts = 'drag-drop-for-schichts',
  EventTextOver = 'event-text-over',
  //PlanningBar
  IconAddress = 'icon-adress',
  IconProject = 'icon-project',
  IconAbo = 'icon-abo',
  IconAutomaticPlanning = 'icon-automatic-planning',
  IconFastPlanning = 'icon-fastplanning',
  IconKalenderArt = 'icon-kalender-art',
  IconSearch = 'icon-search',
  IconSidebar = 'icon-sidebar',
  SchedulerSettings = 'scheduler-settings',
  AdditionalProducts = 'additionalproducts',
  SetInactive = 'setinactive',
  SetActive = 'setactive',
  SetClosed = 'setclosed',
  Invoicing = 'invoicing',
  //Projects
  UpdateReceiptData = 'update-receiptdata',
  ProjectsDocuments = 'documents',
  ProjectsWebReport = 'webreport',
  //Recruiting
  Recruiting = 'recruiting',
  //Tools
  ReleaseIcon = 'icon-releaseFIBUrecords',
  ExportIcon = 'icon-exportFIBUrecords',
  UndoIcon = 'icon-resetFIBUrecords',
  ExcludeIcon = 'icon-excludeFIBUrecords',
  //Cockpit
  Kanban = 'kanban',
  //Products
  ProductsDocuments = 'documents',

  AddressesPlanningSpecifications = 'planning-specifications',
  AddressesWebReport = 'webreport',
  AddressesMultiWebReport = 'multi-webreport',
  MasterDataOperatingResources = 'operating-resources',
  PlanningManualTimeRegistration = 'manual-time-registration',
  PlanningBarShiftsWithTime = 'shifts-with-time',
  ProductsUnitConversion = 'unit-conversion',
  ProductsTurnoverBudget = 'turnover-budget',
  ProductsPartsLists = 'parts-lists',
  ProductsPurchase = 'purchase',
  ProductsLogistics = 'logistics',
  ProductsAlternativeUnits = 'alternative units',
  ProductsSuspensions = 'suspensions',
  ProjectDetailsProcessFlow = 'process-flow',
  ProjectDetailsIconInsert = 'icon-insert-details',
  ProjectDetailsIconUpdate = 'icon-update-details',
  ProjectDetailsIconDelete = 'icon-delete-details',
  ProjectDetailsFastInsert = 'fast-insert-details',
  ProjectsEmailReceiptDelivery =	'e-mail-receipt-delivery',
  ProjectsReceiptExport = 'receipt-export',
  ProjectsPartsLists = 'parts-lists',
  ProjectsUpdateAddress = 'update-projectaddress',
  ProjectsOptions = 'options',
  ProjectsMaterialDisposition = 'material-disposition'
}

export enum ProductAddressEnum { Address,  Price }

export enum KeyActionEnum {
  help = 'F1',
  search = 'F2',
  edit = 'F3',
  create = 'F6',
  save = 'F8',
  delete = 'F7',
  cancel = 'Escape',
  selectAll = 'ctrl+a',
}